import { Client } from '../clientsData';
import AnimatedSection from './AnimatedSection';

function ClientCard({ client }: { client: Client }) {
  const initials = client.name
    .split(' ')
    .slice(0, 2)
    .map(word => word[0])
    .join('');

  return (
    <AnimatedSection animation="scale-in">
      <div className="bg-zinc-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-zinc-200 group">
        <a
          href={client.websiteUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="block"
        >
          {client.logoUrl ? (
            <img
              src={client.logoUrl}
              alt={client.name}
              className="mx-auto h-20 object-contain mb-4 group-hover:scale-105 transition-transform"
            />
          ) : (
            <div className="mx-auto h-20 w-20 rounded-full bg-zinc-800 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <span className="text-[#FDCB12] text-xl font-bold tracking-wide">{initials}</span>
            </div>
          )}
          <p className="text-black text-center font-medium">{client.name}</p>
        </a>
      </div>
    </AnimatedSection>
  );
}

export default ClientCard;
